// extracted by mini-css-extract-plugin
export default {"deco":"DecoItem_deco__Ndhrm","description":"DecoItem_description__Dk6gB","price":"DecoItem_price__+CWSB"};